module.exports = [{"name":"dummy","coord":"155-209"},{"name":"repeat","coord":"15-20"},{"name":"repeat","coord":"5-10"},{"name":"repeat","coord":"25-35"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/KRAS_protein.json
// module id = 41
// module chunks = 0